<template>
    <v-container ma-0 pa-0>
        <v-combobox
            v-model="base"
            :items="get_ListOfAirports()"
            :label="label"
            prepend-icon="mdi-home"
            append-outer-icon="mdi-water"
            clearable
            chips>
        </v-combobox>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { eventBus } from '../../../../../main';


    export default {
        name : 'airportscombo',

        /* >>> *************************************************************** / /* Props */
        props : {

            value : [ String, null ],
            label : String

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/AirportsCombo.vue >>> created');
            eventBus.$on('dragendproceedingslist', this.onDragend_InSelectedProceedingsList);
            eventBus.$on('dragendtrainingslist', this.onDragend_InSelectedTrainingsList);
            eventBus.$on('dragendmeetingslist', this.onDragend_InSelectedMeetingsList);
            eventBus.$on('dragendstandbylist', this.onDragend_InSelectedStandbyList);
            eventBus.$on('dragendofficelist', this.onDragend_InSelectedOfficeList);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/AirportsCombo.vue >>> mounted');
            this.setAirport();

        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note: No need to reset something here.
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/AirportsCombo.vue >>> beforeDestroy');
            eventBus.$off('dragendproceedingslist', this.onDragend_InSelectedProceedingsList);
            eventBus.$off('dragendtrainingslist', this.onDragend_InSelectedTrainingsList);
            eventBus.$off('dragendmeetingslist', this.onDragend_InSelectedMeetingsList);
            eventBus.$off('dragendstandbylist', this.onDragend_InSelectedStandbyList);
            eventBus.$off('dragendofficelist', this.onDragend_InSelectedOfficeList);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                base: null,
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch : {

            value() {

                this.setAirport();

            }, // eo function value()

            base(value) {

                this.$emit('input', value);

            }, // eo function base()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_Airports',
            ])

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods : {

            /******************************************************************* 'Listeners - Eventbus'
            * Listeners:EventBus:
            *******************************************************************/
            /******************************************************************* 'Proceedings - Drop'
            * onDragend_InSelectedProceedingsList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedProceedingsList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/AirportsCombo.vue >>> onDragend_InSelectedProceedingsList');
                if (this.label === 'Select Proceeding From Arprt:') {
                    this.base = params.proObject.codeAptFrom;
                }
                if (this.label === 'Select Proceeding To Arprt:') {
                    this.base = params.proObject.codeAptTo;
                }

            }, // eo function onDragend_InSelectedProceedingsList()


            /******************************************************************* 'Trainings - Drop'
            * onDragend_InSelectedTrainingsList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedTrainingsList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/AirportsCombo.vue >>> onDragend_InSelectedTrainingsList');
                this.base = params.trainingObject.aptFromCode;

            }, // eo function onDragend_InSelectedTrainingsList()


            /******************************************************************* 'Meetings - Drop'
            * onDragend_InSelectedMeetingsList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedMeetingsList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/AirportsCombo.vue >>> onDragend_InSelectedMeetingsList');
                this.base = params.aptCode;

            }, // eo function onDragend_InSelectedMeetingsList()


            /******************************************************************* 'Standby - Drop'
            * onDragend_InSelectedStandbyList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedStandbyList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/AirportsCombo.vue >>> onDragend_InSelectedStandbyList');
                this.base = params.aptCode;

            }, // eo function onDragend_InSelectedStandbyList()


            /******************************************************************* 'Standby - Drop'
            * onDragend_InSelectedOfficeList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedOfficeList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/AirportsCombo.vue >>> onDragend_InSelectedOfficeList');
                this.base = params.aptCode;

            }, // eo function onDragend_InSelectedOfficeList()




            /*******************************************************************
            * Setters:
            *******************************************************************/
            /*******************************************************************
            * setAirport()
            *
            * Desc:
            * Note:
            *
            */
            setAirport: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/AirportsCombo.vue >>> setAirport');
                me.base = this.value;

            }, // eo function setAirport()



            /*******************************************************************
            * Getters:
            *******************************************************************/
            /*******************************************************************
            * get_ListOfAirports()
            *
            * Desc: Return List of Airports.
            * Note:
            *
            */
            get_ListOfAirports: function() {

                let me = this,
                    airports = [];


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/AirportsCombo.vue >>> get_ListOfAirports');
                this.get_Airports.forEach((apt, i) => {
                    airports.push(apt.aptCode);
                });


                return airports;

            }, // eo function get_ListOfAirports()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
</style>